import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faEdit,
    faTrash,
    faTimes,
    faCheckCircle
} from "@fortawesome/free-solid-svg-icons";

import Breadcrumb from "../../../components/Ui_Element/Breadcrumb";
import DotLoader from "../../../components/Ui_Element/DotLoader";
import { post, getlist, deleteitem, getById } from "../../../contexts/apicontexts";
import config from "../../../config";
import { showToast } from "../../../components/Ui_Element/CustomToast";

export default function DefultRoleMenuPermissions() {
    const [isLoder, setIsLoder] = useState(false);
    const [Roles, setRoles] = useState([]);
    const [rows, setRows] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedValue, setSelectedValue] = useState([]);

    useEffect(() => {
        fetchRoles();
        fetchDefultRolesPermissions();
    }, []);
    useEffect(() => {
        fetchDefultRolesPermissions();
    }, [selectedRole]);
    const fetchRoles = async () => {
        setIsLoder(true);
        const response = await getlist(`${config.baseurl}MenuPermission/getallrole`);
        console.log(response);
        if (response?.status === 200) {
            setRoles(response.data || []);
        }
        setIsLoder(false);
    };

    const fetchDefultRolesPermissions = async () => {
        setIsLoder(true);
        const url = `${config.baseurl}MenuPermission/GetDefultRolePermissione?roleid=${selectedRole}`;
        const response = await getById(url);
        console.log("response", response);
        if (response?.status === 200) {
            setRows(response.data || []);
        }
        setIsLoder(false);
    };
    const handleRoleChange = (e) => {
        const roleId = e.target.value;
        setSelectedRole(roleId);

    };
    const togglePermission = (moduleIndex, permIndex, field) => {
        // 1️⃣ Update the rows (UI state)
        const updatedRows = [...rows];
        updatedRows[moduleIndex].rolePermissions[permIndex][field] =
            !updatedRows[moduleIndex].rolePermissions[permIndex][field];
        setRows(updatedRows);

        // 2️⃣ Update selectedValue (tracking changes)
        const row = updatedRows[moduleIndex].rolePermissions[permIndex];
        const updatedSelected = [...selectedValue];
        const existingIndex = updatedSelected.findIndex(item => item.menuName === row.menuName);

        if (existingIndex !== -1) {
            // Update existing
            updatedSelected[existingIndex][field] = row[field];
            const { canAdd, canEdit, canDelete, canView, id } = updatedSelected[existingIndex];

            // If new row (id null) and all permissions false → remove
            if (id === null && !canAdd && !canEdit && !canDelete && !canView) {
                updatedSelected.splice(existingIndex, 1);
            }
        } else {
            // Add new row
            updatedSelected.push({
                id: row.id,
                menuId: row.menuId,
                menuName: row.menuName,
                canAdd: field === "canAdd" ? row.canAdd : row.canAdd,
                canEdit: field === "canEdit" ? row.canEdit : row.canEdit,
                canDelete: field === "canDelete" ? row.canDelete : row.canDelete,
                canView: field === "canView" ? row.canView : row.canView,
            });
        }

        setSelectedValue(updatedSelected);
    };
    const handleSave = async () => {
        // 1️⃣ Validate role
        if (!selectedRole) {
            showToast.warning("Please select a role first");
            return;
        }

        // 2️⃣ Validate menu selection
        if (!selectedValue || selectedValue.length === 0) {
            showToast.warning("Please select at least one menu permission");
            return;
        }

        // 3️⃣ Prepare payload
        const menus = selectedValue.map(item => ({
            id: item.id,                 // null or existing id
            roleId: selectedRole,
            menuId: item.menuId,
            canAdd: item.canAdd,
            canEdit: item.canEdit,
            canDelete: item.canDelete,
            canView: item.canView
        }));
        const payload = {
            RoleId: selectedRole,
            models: menus

        };
        console.log("SAVE PAYLOAD 👉", payload);

        try {
            setIsLoder(true);

            const response = await post(
                `${config.baseurl}MenuPermission/SaveDefaultRolePermissions`,
                payload
            );

            if (response?.status === 200) {
                showToast.success("Permissions saved successfully.");
                setSelectedValue([]);
                fetchDefultRolesPermissions(); // refresh UI
            }
        } catch (error) {
            console.error(error);
            showToast.error("Something went wrong.");
        } finally {
            setIsLoder(false);
        }
    };


    console.log("rows", rows);
    console.log("selectedValue", selectedValue);

    return (
        <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
            <Breadcrumb pageName="Default Role Permissions" currentPage="Default Role Permissions" />

            <div className="bg-white rounded-xl shadow border mt-4 overflow-hidden">

                {/* HEADER (APPLIED DESIGN) */}
                <div className="card-header flex justify-between items-center px-5 py-3 border-b transition-colors duration-300
                    bg-gradient-to-r from-[#C04C2A] to-[#4A1B13]
                    dark:from-[#2D120D] dark:to-[#1A1A1A] dark:border-gray-800">

                    <div className="flex items-center gap-3">
                        <h2 className="text-xl md:text-2xl font-bold text-white tracking-tight">
                            Default Role Permissions
                        </h2>
                        {isLoder && <DotLoader color="#ffffff" size="w-1.5 h-1.5" />}
                    </div>
                </div>



                <div className="mt-4 p-2 ">
                    <div className="flex flex-col md:flex-row gap-4 border-gray-400">
                        {/* Left Column (Role Dropdown) */}
                        <div className="md:w-1/3 mb-4">
                            <select
                                value={selectedRole}
                                onChange={handleRoleChange}
                                className={`w-full border px-4 py-2.5 rounded-xl dark:bg-gray-800 dark:text-white
                        outline-none focus:ring-2 border-gray-400 dark:border-gray-700 focus:ring-orange-100 focus:border-[#C04C2A]
                    `}
                            >
                                <option value="">Select Role</option>
                                {Roles.map((role) => (
                                    <option key={role.id} value={role.id} className="dark:bg-gray-800 dark:text-gray-200">
                                        {role.name}
                                    </option>
                                ))}
                            </select>
                            ..
                        </div>

                        {/* Right Column (Module Cards) */}
                        <div className="md:w-2/3 space-y-4">
                            {rows.map((module, moduleIndex) => (
                                <div
                                    key={module.id}
                                    className=" bg-gray-50 p-4 dark:bg-gray-800 rounded-xl shadow  border dark:border-gray-700"
                                >
                                    <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-3">
                                        {module.moduleName}
                                    </h3>

                                    {/* Role Permissions */}
                                    {module.rolePermissions.map((perm, permIndex) => (
                                        <div
                                            key={perm.menuId}
                                            className="flex flex-col md:flex-row md:items-center justify-between bg-white dark:bg-gray-700 p-2 rounded mb-2 border dark:border-gray-600"
                                        >
                                            <span className="text-gray-800 dark:text-gray-200 mb-1 md:mb-0">
                                                {perm.menuName}
                                            </span>
                                            <div className="flex gap-2 flex-wrap">
                                                <label className="flex items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        checked={perm.canAdd}
                                                        onChange={() => togglePermission(moduleIndex, permIndex, "canAdd")}
                                                        className="accent-green-500"
                                                    />
                                                    Add
                                                </label>
                                                <label className="flex items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        checked={perm.canEdit}
                                                        onChange={() => togglePermission(moduleIndex, permIndex, "canEdit")}
                                                        className="accent-blue-500"
                                                    />
                                                    Edit
                                                </label>
                                                <label className="flex items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        checked={perm.canDelete}
                                                        onChange={() => togglePermission(moduleIndex, permIndex, "canDelete")}
                                                        className="accent-red-500"
                                                    />
                                                    Delete
                                                </label>
                                                <label className="flex items-center gap-1">
                                                    <input
                                                        type="checkbox"
                                                        checked={perm.canView}
                                                        onChange={() => togglePermission(moduleIndex, permIndex, "canView")}
                                                        className="accent-indigo-500"
                                                    />
                                                    View
                                                </label>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}


                            <button
                                type="button"
                                onClick={handleSave}
                                disabled={isLoder}
                                className="flex-1 px-4 py-3 mt-5 mb-5 text-white font-bold rounded-xl
                                    shadow-lg transform transition-all active:scale-95 disabled:opacity-70"
                                style={{
                                    background: "linear-gradient(to right, #C04C2A, #4A1B13)"
                                }}
                            >
                                {isLoder ? (
                                    <DotLoader color="#fff" size="w-1.5 h-1.5" />
                                ) : (
                                    "Save Menu Permissions"
                                )}
                            </button>
                        </div>
                    </div>

                </div>


            </div>
        </div>

    )
}